import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../Auth.css";

class Register extends Component {
  constructor() {
    super();

    this.state = {
      name: "",
      mobile: "",
      password: "",
      confirmPassword: ""
    };
  }



  // ✅ INPUT HANDLE
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };



  // ✅ REGISTER
  handleRegister = async () => {
    const {
      name,
      mobile,
      password,
      confirmPassword
    } = this.state;

    // Empty check
    if (
      !name ||
      !mobile ||
      !password ||
      !confirmPassword
    ) {
      alert("Please fill all fields ❌");
      return;
    }

    // Mobile length check
    if (mobile.length !== 10) {
      alert("Enter valid mobile number ❌");
      return;
    }

    // Password match
    if (password !== confirmPassword) {
      alert("Passwords do not match ❌");
      return;
    }

    try {
      const response = await fetch(
        "https://api.hi-bigame.online/register",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify({
            username: name,
            mobile: mobile,
            password: password
          })
        }
      );

      const data = await response.json();

      alert(data.message || "Registered");

      if (data.success) { this.props.navigate("/"); }

    } catch (error) {
      console.log(error);

      alert("Server Error ❌");
    }
  };



  render() {
    return (
      <div className="auth-bg">

        <div className="auth-card">

          <div className="logo"> HI-BI </div>

          <h3>Create Account </h3>

          <p className="field-title"> Full Name: </p>

          <input className="auth-input" type="text" name="name" placeholder="Full Name" value={this.state.name} onChange={this.handleChange} />

          <p className="field-title"> Mobile Number:</p>

          <input className="auth-input" type="tel" name="mobile" placeholder="Mobile Number" value={this.state.mobile} onChange={this.handleChange} />

          <p className="field-title"> Password:</p>

          <input className="auth-input" type="password" name="password" placeholder="Password" value={this.state.password} onChange={this.handleChange} />

          <p className="field-title"> Confirm Password: </p>

          <input className="auth-input" type="password" name="confirmPassword" placeholder="Confirm Password" value={this.state.confirmPassword}
            onChange={this.handleChange} />

          <button className="auth-btn" onClick={this.handleRegister}> Register</button>

          <div className="link" onClick={() => this.props.navigate( "/" )}>Already have account? Login</div>
        </div>
      </div>
    );
  }
}

export default withNavigation(Register);